import React, { useState } from "react";
import { Form } from "semantic-ui-react";
import { truncate, get, isEmpty } from "lodash";
import PropTypes from "prop-types";
// redux
import { sheduleChat } from "@Actions/chats";
import { connect } from "react-redux";
import Input from "@Components/Input";
import Text from "@Components/Text";
import IKModal from "@Components/IkModal";
import Moment from "moment";
import styles from "./style.module.css";

const Shedule = ({ chatCurrent, dispatch, onClose }) => {
	const [concept, setConcept] = useState("");
	const [dateTime, setDateTime] = useState("");
	const [messageArea, setMessageArea] = useState("");

	const [errors, setErrors] = useState({
		dateTime: "",
		concept: "",
		channel: "",
		phone: "",
		department: "",
	});

	const handleError = async () => {
		const fechaLimit = timeLimit();

		if (fechaLimit) {
			const sheduleModalVal = {
				concept,
				scheduleDate: dateTime,
				note: messageArea,
			};
			await dispatch(sheduleChat(get(chatCurrent, "id", ""), sheduleModalVal));
			onClose();
			setErrors({
				dateTime: "",
				concept: "",
				channel: "",
				phone: "",
				department: "",
			});
		} else {
			setErrors({
				...errors,
				dateTime: "Fecha inválida ( Hora debe ser 30 minutos mayor a la Hora Actual).",
			});
		}
	};
	const timeLimit = () => {
		const hoy = new Date();
		const dateInput = new Date(dateTime);
		const minutesToAdd = 30;
		const dateInputUpd = new Date(hoy.getTime() + minutesToAdd * 60000);
		if (dateInputUpd <= dateInput) {
			return true;
		}
		return false;
	};

	const handleInputTextArea = (value) => {
		let number = value;
		if (value.length > 499) {
			number = truncate(value, {
				length: 500,
				omission: "",
			});
		}
		setMessageArea(number);
	};

	return (
		<IKModal
			title="Agendar Chat"
			// id={tableValue.id}
			// mode={modalOption}
			// setMode={setModalOption}
			onClose={onClose}
			onSuccess={handleError}
			size="small">
			<div className={styles.div}>
				<fieldset className={styles.fieldset}>
					<div className={styles.textTyle}>Concepto:</div>
					<Input
						icon="address book"
						fluid
						className={styles.input}
						value={concept}
						setConcept
						onChange={(e) => {
							return setConcept(e.target.value);
						}}
					/>

					<div className={styles.textTyle}>Fecha y Hora a trabajar:</div>

					<Input
						type="datetime-local"
						min={Moment().format("YYYY-MM-DDTHH:mm")}
						error={!isEmpty(errors.dateTime) && { content: errors.dateTime, pointing: "above" }}
						name="dateTime"
						value={dateTime}
						className={styles.input}
						onChange={(e) => {
							return setDateTime(e.target.value);
						}}
					/>

					<Form>
						<div className={styles.rowTitleImg}>
							<Text className={styles.textArea}> Nota: </Text>
							<Text className={messageArea.length === 500 ? styles.textAreaColor : styles.textArea}>
								{messageArea.length}
								/500
							</Text>
						</div>
						<Form.TextArea
							name="messageArea"
							value={messageArea}
							onChange={(e) => {
								return handleInputTextArea(e.target.value);
							}}
							className={styles.input}
							fluid
							placeholder="Escribe aqui..."
						/>
					</Form>
				</fieldset>
			</div>
		</IKModal>
	);
};
Shedule.propTypes = {
	chatCurrent: PropTypes.array,
	dispatch: PropTypes.func,
	onClose: PropTypes.func,
};
export default connect()(Shedule);
